import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const appRoutes: Routes = [
	{
		path: 'docs',
		loadChildren: () => import('./pages/page.routes'),
		canMatch: [authGuard],
	},
	{
		path: '**',
		redirectTo: 'docs',
		pathMatch: 'full',
	},
];
